import {
  CatalogueOffer
} from '../models';

export const mapCatalogueOffer = (result) => {

  return new CatalogueOffer(result).mapToStandard();
};